import {
  IAddSupplementToInquiryPayload,
  ICreateInquiry,
  ICreateInquiryPayload,
  IInquiriesSearchPayload,
  IInquiriesTableData,
  IInquiryDetails,
  IInquiryResponse,
  IPrintInquiryResponse,
  ISharedInquiryResponse,
  IShareInquiryResponsePayload,
  IShareInquiryResponseResult,
  ISubmitInquiryPayload,
} from '@interfaces/inquiries';

import { apiUrls } from './urls';
import { deletes, get, post } from './utils';

export const inquiries = (payload: IInquiriesSearchPayload) =>
  post<IInquiriesTableData>(apiUrls.inquiries.search, payload);

export const createInquiry = (payload: ICreateInquiryPayload) =>
  post<ICreateInquiry>(apiUrls.inquiries.create, payload);

export const addSupplementToInquiry = (payload: IAddSupplementToInquiryPayload) =>
  post(apiUrls.inquiries.addSupplement, payload);

export const deleteInquiryDraft = (id: number) => deletes(`${apiUrls.inquiries.deleteDraft}/${id}`);

export const removeSupplementFromInquiryDraft = (id: number) =>
  deletes(`${apiUrls.inquiries.removeSupplementInquiry}/${id}`);

export const submitInquiry = (payload: ISubmitInquiryPayload) =>
  post(apiUrls.inquiries.submit, payload);

export const getDetailsOfInquiry = (id: number) =>
  get<IInquiryDetails>(`${apiUrls.inquiries.details}/${id}`);

export const getInquiryResponse = (inquiryId: number) =>
  get<IInquiryResponse>(`${apiUrls.inquiries.response}/${inquiryId}`);

export const getPrintInquiryResponse = (inquiryId: number) =>
  get<IPrintInquiryResponse>(`${apiUrls.inquiries.printViewData}/${inquiryId}`);

export const shareInquiryResponse = (payload: IShareInquiryResponsePayload) =>
  post<IShareInquiryResponseResult>(apiUrls.inquiries.shareInquiry, payload);

export const getSharedInquiryResponse = (sharedInquiryUUID: string) =>
  post<ISharedInquiryResponse>(`${apiUrls.inquiries.sharedInquiryData}/${sharedInquiryUUID}`);
